import React, {useState} from "react";
import {Button, Menu, MenuItem} from "@mui/material";
import {useAnalyticsPreferencesMenu} from "./AnalyticsConsent";

/** Inline settings access where an account menu is unavailable. */
export default function AnalyticsSettingsMenu({sx}) {
  const [anchor, setAnchor] = useState(null);
  const openPreferences = useAnalyticsPreferencesMenu(() => setAnchor(null));
  if (!openPreferences) return null;
  return <>
    <Button type="button" size="small" sx={sx} aria-label="Settings menu"
      aria-haspopup="menu" aria-expanded={Boolean(anchor)} onClick={(event) => setAnchor(event.currentTarget)}>
      Settings
    </Button>
    <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)} sx={{zIndex: 2700}}>
      <MenuItem onClick={openPreferences}>Analytics preferences</MenuItem>
    </Menu>
  </>;
}
